import React from 'react';

const OptionalExternalLink = ({ href, children }) => {
  if (!href) {
    return children;
  }

  return (
    <a href={href} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
      {children}
    </a>
  );
};

export default OptionalExternalLink;
